document.addEventListener("scroll", (event) => {
    const backToTopButton = document.getElementById('back-to-top');
    const showOnPx = 100;
    function scrollToTop() {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }
    if (+window.scrollY > showOnPx) {
        backToTopButton.classList.remove("is-transparent");
        backToTopButton.addEventListener("click", scrollToTop);
    } else {
        backToTopButton.classList.add("is-transparent");
        backToTopButton.removeEventListener("click", scrollToTop);
    }

});
